import { render, staticRenderFns } from "./AcessoUser.vue?vue&type=template&id=7bebe8b4"
import script from "./AcessoUser.vue?vue&type=script&lang=js"
export * from "./AcessoUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports